export default {
  title: 'Incidents',
  description: 'Système de gestion des incidents',
  create: 'Créer un incident',
  noResults: 'Aucun incident trouvé',
  stats: {
    total: 'Total',
    open: 'Ouverts',
    inProgress: 'En cours',
    resolved: 'Résolus',
    closed: 'Fermés',
    critical: 'Critiques',
    high: 'Élevés'
  },
  filters: {
    status: 'Statut',
    severity: 'Sévérité',
    category: 'Catégorie'
  },
  fields: {
    title: 'Titre',
    status: 'Statut',
    severity: 'Sévérité',
    category: 'Catégorie',
    productionLine: 'Ligne de production',
    reportedBy: 'Signalé par',
    reportedAt: 'Signalé le',
    assignedTo: 'Assigné à',
    description: 'Description'
  },
  status: {
    open: 'Ouvert',
    in_progress: 'En cours',
    resolved: 'Résolu',
    closed: 'Fermé'
  },
  severity: {
    low: 'Faible',
    medium: 'Moyenne',
    high: 'Élevée',
    critical: 'Critique'
  },
  category: {
    quality: 'Qualité',
    safety: 'Sécurité',
    equipment: 'Équipement',
    process: 'Processus',
    other: 'Autre'
  },
  sort: {
    'reportedAt-desc': 'Plus récents',
    'reportedAt-asc': 'Plus anciens',
    'severity-desc': 'Sévérité (Élevée à Faible)',
    'severity-asc': 'Sévérité (Faible à Élevée)',
    'title-asc': 'Titre (A-Z)',
    'title-desc': 'Titre (Z-A)'
  },
  kanban: {
    noIncidents: 'Aucun incident'
  },
  view: {
    list: 'Vue liste',
    kanbanStatus: 'Kanban par statut',
    kanbanSeverity: 'Kanban par sévérité'
  }
}
